<tix-card>
  <tix-card-header>
    <tix-card-title class="flex items-center space-x-2">
      <tix-back-button> </tix-back-button> <span>Profile</span>
    </tix-card-title>
  </tix-card-header>
  <tix-card-content>
    <form [formGroup]="profileForm">
      <div class="profile-content-layout">
        <mat-form-field>
          <mat-label>First name</mat-label>
          <input
            [readonly]="!!selectedExistingUser"
            matInput
            type="text"
            formControlName="contactFirstName"
          />
        </mat-form-field>
        <mat-form-field>
          <mat-label>Last name</mat-label>
          <input
            [readonly]="!!selectedExistingUser"
            matInput
            type="text"
            formControlName="contactLastName"
          />
        </mat-form-field>
        <mat-form-field class="position-relative col-span-2">
          <mat-label>Email</mat-label>
          <input
            matInput
            type="text"
            formControlName="contactEmailAddress"
            role="presentation"
            autocomplete="off"
            [readonly]="isEditMode || !!selectedExistingUser"
            [matAutocomplete]="auto"
          />
          <mat-autocomplete #auto="matAutocomplete">
            <mat-option
              *ngFor="let user of emailList$ | async"
              (onSelectionChange)="getUserInfoByEmail(user)"
              >{{ user.emailAddress }}</mat-option
            >
          </mat-autocomplete>
        </mat-form-field>
      </div>
      <ng-container *ngIf="!isEditMode">
        <div class="mb-3.5 relative">
          <tix-card-title>Permissions</tix-card-title>
          <span
            class="text-primary material-icons cursor-pointer absolute -top-1 left-[6.7rem]"
            matTooltip="Click for more info"
            (click)="openHelpDialog()"
            >info</span
          >
        </div>

        <div class="permissions-content-layout">
          <div
            class="permission-box-layout bg-[#dde3ea80] border border-gray-300"
            *ngFor="let item of userRolesList$ | async as roleList"
          >
            <tix-checkbox
              [labelPosition]="'before'"
              [value]="item.roleId"
              (change)="onChange($event, item)"
              [disabled]="isEventAdminSelected && item.role !== 'event_admin'"
              [checked]="profileForm.value.permissions.includes(item.roleId)"
            >
              {{ item?.title }}
            </tix-checkbox>
          </div>
        </div>
      </ng-container>
    </form>
  </tix-card-content>

  <tix-card-actions
    class="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-end"
  >
    <button
      *ngIf="(isAdmin$ | async) && currentStaffId !== (userId$ | async)"
      tix-flat-border-button
      color="danger"
      class="w-full sm:w-auto px-6 py-1.5 sm:py-1 text-sm font-medium order-2 sm:order-1"
      (click)="handleDelete()"
    >
      <div
        *ngIf="!isloading && !(isDeleting$ | async)"
        class="flex items-center justify-center"
      >
        Delete Staff
      </div>
      <div
        *ngIf="isloading || (isDeleting$ | async)"
        class="flex items-center justify-center space-x-2"
      >
        <span
          class="mr-2"
          *tixBtnLoading="isloading || (isDeleting$ | async)"
        ></span>
        <span>Loading</span>
      </div>
    </button>

    <button
      mat-button
      (click)="onSave()"
      class="w-full sm:w-auto min-w-[160px] px-6 py-1.5 sm:py-1 bg-primary text-white font-medium order-1 sm:order-2"
      [ngClass]="[
        !isSaveButtonDisabled ? 'cursor-not-allowed' : 'cursor-pointer',
        !isSaveButtonDisabled && !isloading
          ? 'hover:bg-gray-300 hover:text-gray-700 hover:opacity-50'
          : 'hover:bg-primary-700'
      ]"
      [disabled]="!isSaveButtonDisabled"
    >
      <div *ngIf="!isloading" class="flex items-center justify-center">
        <span class="material-icons-outlined mr-2 text-lg">save</span>
        <span>Save Changes</span>
      </div>
      <div *ngIf="isloading" class="flex items-center justify-center space-x-2">
        <span
          class="mr-2"
          *tixBtnLoading="isloading || (isSaving$ | async)"
        ></span>
        <span>Loading</span>
      </div>
    </button>
  </tix-card-actions>
</tix-card>
